import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { PageBanner } from "../components/PageBanner";
import { ValuesMarquee } from "../components/ValuesMarquee";
import { CTABand } from "../components/CTABand";
import { About } from "../components/home/About";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <Header />
      <main>
        <PageBanner
          testId="about-banner"
          eyebrow="About BMS"
          title="About Us"
          description="Get to know the people, values, and commitment behind BMS Health Care Services — a locally owned home care provider proudly serving Surrey and the Lower Mainland."
        />
        <About />
        <ValuesMarquee />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
}
